import React, { useEffect, useState } from 'react';
import SVG from 'react-inlinesvg';
import Search from '../../common/formParts/icons/Search.svg'
import Remove from '../../common/formParts/icons/Times.svg'

import {
  MemberTabs,
  TabHeads,
  CheckBoxesTabHead,
  CheckBoxesTabHeadActive,
  SelectedMembersTabHead,
  CheckBoxesTab,
  SelectedMembersTab,
  SelectedMembersTabHeadActive,
  LiUser,
  SelectAll,
} from '../../common/formParts/FieldPartsStyled'


const UserArticleTabs = (props) => {
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('会員住戸選択');
  const [selectAllChecked, setSelectAllChecked] = useState(props.selectedMembers.length === props.users.length);
  const [visibleUsers, setVisibleUsers] = useState(props.users || []);
  const [selectedUsers, setSelectedUsers] = useState(props.selectedMembers || []);
  const [selectedUsersCount, setSelectedUsersCount] = useState(props.selected ? props.selectedMembers.length : 0);
  const [selectAllText, setSelectAllText] = useState('全選択');
  const [currentUserSortOrder, setCurrentUserSortOrder] = useState('asc');

  useEffect(() => {
    setVisibleUsers(props.users || []);
    setSelectedUsers(props.selectedMembers || []);
    setSelectedUsersCount(props.selected ? props.selectedMembers.length : 0);
    setSelectAllChecked(false);
  }, [props.users, props.selectedMembers]);


  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    if (event.target.value === '') {
      setVisibleUsers(props.users);
    } else {
      const filteredUsers = props.users.filter((user) =>
        user.name.toLowerCase().includes(event.target.value.toLowerCase()) || user.room.toLowerCase().includes(event.target.value.toLowerCase())
      );
      setVisibleUsers(filteredUsers);
    }
    // setSelectedUsers([]);
    // setSelectedUsersCount(0);
  };

  const clearSearch = () => {
    setSearchText('');
    setVisibleUsers(props.users);
  };

  const handleCheckboxChange = (event, user) => {
    // console.log(user)
    if (event.target.checked) {
      setSelectedUsers([...selectedUsers, user]);
      setSelectedUsersCount(selectedUsersCount + 1);
      var test = document.getElementById('selected-num');
      test.classList.add('pulse');
    } else {
      setSelectedUsers(selectedUsers.filter((member) => member.user_article_id !== user.user_article_id));
      setSelectedUsersCount(selectedUsersCount - 1);
    }
  };

  const handleTransitionEnd = (event) => {
    var test = document.getElementById('selected-num');
    test.classList.remove('pulse');
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const unselectUser = (user) => {
    setSelectedUsers(selectedUsers.filter((member) => member.user_article_id !== user.user_article_id));
    setSelectedUsersCount(selectedUsersCount - 1);
    if (selectAllChecked) {
      setSelectAllChecked(false);
    }
  };

  const handleSelectAllChange = (event) => {
    const isChecked = event.target.checked;
    if (selectAllText === '全解除') {
      setSelectedUsers([]);
      setSelectedUsersCount(0);
      setSelectAllChecked(false);
    } else if (selectAllChecked === false && selectAllText === '全選択') {
      setSelectedUsers(visibleUsers);
      setSelectedUsersCount(visibleUsers.length);
      setSelectAllChecked(true);
    }
  };

  useEffect(() => {
    if (selectedUsersCount > 0) {
      setSelectAllText('全解除');
    } else {
      setSelectAllText('全選択');
    }
  }, [selectedUsersCount]);

  const orderByRoomNumber = (sortOrder) => {
    const collator = new Intl.Collator('ja-JP', {numeric: true, sensitivity: 'base'});
    const sortUsers = (users, order) => {
      return [...users].sort((a, b) => {
        return order === 'asc' ? collator.compare(a.room, b.room) : collator.compare(b.room, a.room);
      });
    };

    const sortedVisibleUsers = sortUsers(visibleUsers, sortOrder);
    const sortedSelectedUsers = sortUsers(selectedUsers, sortOrder);

    setVisibleUsers([...sortedVisibleUsers]);
    setSelectedUsers([...sortedSelectedUsers]);
    setCurrentUserSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
  }

  return (
    <MemberTabs>
      <TabHeads>
        {activeTab === '会員住戸選択' ? (
          <CheckBoxesTabHeadActive>
            <span>会員住戸選択</span>
          </CheckBoxesTabHeadActive>
        ) : (
          <CheckBoxesTabHead>
            <a href="#"
              onClick={(e) => { e.preventDefault(); handleTabChange('会員住戸選択') }}>
              会員住戸選択
            </a>
          </CheckBoxesTabHead>
        )
        }

        {activeTab === '選択済み会員' ? (
          <SelectedMembersTabHeadActive>
            <span>
              選択済み会員住戸
              <div onAnimationEnd={handleTransitionEnd} id="selected-num" className={selectedUsersCount > 0 ? "count active pulse" : "count"}>{selectedUsersCount}</div>
            </span>
          </SelectedMembersTabHeadActive>
        ) : (
          <SelectedMembersTabHead>
            <a href="#"
              onClick={(e) => { e.preventDefault(); handleTabChange('選択済み会員') }}
            >
              選択済み会員住戸
              <div onAnimationEnd={handleTransitionEnd} id="selected-num" className={selectedUsersCount > 0 ? "count active pulse" : "count"}>{selectedUsersCount}</div>
            </a>
          </SelectedMembersTabHead>
        )
        }

      </TabHeads>
      {activeTab === '会員住戸選択' && (
        <CheckBoxesTab>
          <div className='searchMembers'>
            <SVG src={Search} className='icon' />
            <input
              type="text"
              placeholder="検索"
              value={searchText}
              onChange={handleSearchChange}
            />
            {searchText !== '' && (
              <a href="#"
                onClick={(e) => { e.preventDefault(); clearSearch() }}>
                <img src={Remove} />
              </a>)}
          </div>
          <SelectAll>
            <div>
              <div className='SelectAllCheckbox'>
                <input
                  type="checkbox"
                  id={`select-all-${props.indexId}`}
                  checked={selectAllChecked}
                  onChange={handleSelectAllChange}
                />
                <label htmlFor={`select-all-${props.indexId}`}>{selectAllText}</label>
              </div>
            </div>
            <div className="membersNameAndNumber">
              会員名
            </div>
            <div className='membersNameAndNumber roomNumber'>
              <div>&#8597; <a href='#' onClick={(e)=> {e.preventDefault(); orderByRoomNumber(currentUserSortOrder)}}>部屋番号</a></div>
            </div>
          </SelectAll>
          <ul>
            {visibleUsers.map((user) => (
              props.selected !== null &&
              <LiUser key={`selectable-${props.selected.value}-${user.user_article_id}`} className={selectedUsers.some((member) => member.user_article_id === user.user_article_id) ? 'isActive' : ''}>
                <label key={`selectable-label-${props.selected.value}-${user.user_article_id}`} className="membersLabel" htmlFor={`user-${props.selected.value}-${user.user_article_id}`}>
                  <div>
                    <input
                      type="checkbox"
                      id={`user-${props.selected.value}-${user.user_article_id}`}
                      checked={selectedUsers.some((member) => member.user_article_id === user.user_article_id)}
                      onChange={(event) => handleCheckboxChange(event, user)}
                      defaultValue={user.user_article_id}
                      name={`news[member_dwelling_unit][${props.selected.value}][selected_members][]` || ''}
                      data-username={user.name}
                      data-room={user.room || ''}
                      data-destination-name={props.selected.label || ''}
                    />
                  </div>
                  <div>{user.name}</div>
                  <div>{user.room}</div>
                </label>
              </LiUser>
            ))}
          </ul>
        </CheckBoxesTab>
      )}
      {activeTab === '選択済み会員' && (
        <SelectedMembersTab>
          <div className='nameAndRoomNumber'>
            <div className='name'>
              会員名
            </div>
            <div className='roomNumber'>
              部屋番号
            </div>
          </div>
          {selectedUsers.length === 0 ? (
            <p className="emptyMessage">選択された会員住戸は存在しないようです</p>
          ) : (
            <ul>
              {selectedUsers.map((user) => (
                props.selected !== null &&
                <LiUser key={'selected-members-' + props.selected.value + '-' + user.user_article_id} className='selectedUsers'>
                  <div>{user.name}</div>
                  <div>{user.room}</div>
                  <div>
                    <a href="#" onClick={(e) => { e.preventDefault(); unselectUser(user) }}>
                      <SVG src={Remove} className='icon' />
                    </a>
                  </div>
                  <input
                    type="hidden"
                    name={`news[member_dwelling_unit][${props.selected.value}][selected_members][]`}
                    value={user.user_article_id}
                    data-username={user.name}
                    data-room={user.room || ''}
                    data-destination-name={props.selected.label || ''}
                  />
                </LiUser>
              ))}
            </ul>
          )}
        </SelectedMembersTab>
      )}
    </MemberTabs>
  );
};

export default UserArticleTabs;
